module.exports = "<div *ngIf=\"currentType && currentType.description && drawerTitleLabel && lang\" class=\"help-drawer\" [class.opened]=\"state === 'opened'\" [@fadeInfadeOut] >\n  \t<div class=\"content-helper\">\n\t    <button class=\"big-red-button\" (click)=\"switchState()\" >{{ drawerTitleLabel[lang] }}</button>\n\n\t    <div class=\"help-drawer-content-container\" [innerHTML]=\"currentType.description[lang]\">\n\t    </div>\n  \t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/help-drawer/help-drawer.component.html
// module id = ./src/app/help-drawer/help-drawer.component.html
// module chunks = main